import { render, staticRenderFns } from "./AppInstall.vue?vue&type=template&id=b7620e9e&scoped=true&"
import script from "./AppInstall.vue?vue&type=script&lang=js&"
export * from "./AppInstall.vue?vue&type=script&lang=js&"
import style0 from "./AppInstall.vue?vue&type=style&index=0&id=b7620e9e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7620e9e",
  null
  
)

export default component.exports